// ----------------------------------------------------------------------

export default function Stepper(theme?:React.CSSProperties | any) {
  return {
    MuiStepConnector: {
      styleOverrides: {
        line: {
          borderColor: theme.palette.divider,
        },
      },
    },
  };
}
